import { apiConfig } from '@/services/api-config';

export default async function (tokenKey: string, stEmail: string) {
  return apiConfig
    .get(`api/DocumentPaliative/get-by-document_producer?email=${stEmail}&tokenKey=${tokenKey}`)
    .then((response) => response.data)
    .catch(() => []);
}
